export const legacyBatchTypes = {
  LIST_LEGACY_BATCH: 'LIST_LEGACY_BATCH',
  LIST_LEGACY_BATCH_SUCCESS: 'LIST_LEGACY_BATCH_SUCCESS',
  LIST_LEGACY_BATCH_FAIL: 'LIST_LEGACY_BATCH_FAIL',
  
};
